/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Common_Updated_AtInputs */



/**
* | output |
* | --- |
* | "Updated {date}" |
*
* @param {Common_Updated_AtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const common_updated_at = /** @type {((inputs: Common_Updated_AtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Updated_AtInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktualisiert am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
});